import styled, {css} from "styled-components";
import {LinkNavigationId} from "../../../../services/configurations/config-data-sections/generated-config-const";

interface SideMenuCrossBrandsListItemIconBoxProps {
    linkId: LinkNavigationId;
}

function getBackGroundPosition(linkId: LinkNavigationId) {
    switch (linkId) {
        case '888SiteLink':
            return css`background-position: -43px -681px;`;
        case 'pokerLink':
            return css`background-position: -103px -681px;`;
        case 'sportLink':
            return css`background-position: -158px -681px`;
        case 'casinoLink':
            return css`background-position: -268px -681px;`;
        default:
            return css``;

    }
}

export const SideMenuCrossBrandsListItemIconBox = styled.i<SideMenuCrossBrandsListItemIconBoxProps>`
  background-image: url("${props => props.theme.images.spriteSheet.toString()}");
  background-repeat: no-repeat;
  display: inline-block;
  width: 30px;
  height: 20px;
  margin: 0 0 0.5rem 0;
  
  ${props => getBackGroundPosition(props.linkId)}
  
`